import SharedProcessingTimeSection from "@/components/feature/SharedProcessingTimeSection";
import type { ProcessingOption } from "@/components/feature/SharedProcessingTimeSection";

const options: ProcessingOption[] = [
  {
    speed: "2–9",
    unit: "Business Days",
    label: "Fast Passport Center",
    tag: "Most Popular",
    tagColor: "bg-[#F6C344] text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission — no drive to downtown Atlanta needed",
      "Ideal for North Fulton tech executives on overseas business trips",
      "Perfect for Alpharetta families with international vacation plans",
      "Great for corporate relocations to European offices",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: true,
  },
  {
    speed: "3–5",
    unit: "Weeks",
    label: "Fast Passport Center",
    tag: "Standard Expedited",
    tagColor: "bg-[#1A365D]/10 text-[#1A365D]",
    features: [
      "Registered U.S. Department of State Courier",
      "Reserved agency submission",
      "Faster than self-service at Fulton County post offices",
      "Good for planned international trips from ATL",
      "Document review included",
      "Dedicated agent assigned to your case",
      "Daily status updates — never left guessing",
      "Not affected by government shutdowns",
    ],
    highlight: false,
    smartSaver: true,
  },
  {
    speed: "1–2",
    unit: "Months",
    label: "Self-Service (Post Office)",
    tag: "Slowest",
    tagColor: "bg-gray-100 text-gray-400",
    features: [
      "No courier access — standard mail only",
      "No document review — errors cause rejection",
      "In-person clerk appointment required at Alpharetta area facilities",
      "Workload shifts with government shutdowns and budget fights",
      "No dedicated agent — you are on your own",
      "Updates only by physical mail letter",
      "No phone or email contact for your case",
      "Cannot upgrade speed after submission",
      "Not suitable if travel is within 10 weeks",
    ],
    highlight: false,
    muted: true,
  },
  {
    speed: "24",
    unit: "Hours*",
    label: "Regional Agency Processing",
    tag: "Emergency Only",
    tagColor: "bg-gray-100 text-gray-500",
    features: [
      "Closest regional agency: Atlanta — ~25 miles via GA-400/I-85",
      "NPIC appointment required before driving to downtown Atlanta",
      "Life-or-death emergencies only",
      "Bereavement or medical crisis documentation required",
      "Expect to wait all day or return next day",
    ],
    highlight: false,
    emergency: true,
  },
];

export default function AlpharettaProcessingTimeSection() {
  return (
    <SharedProcessingTimeSection
      sectionId="processing-options"
      cityName="Alpharetta"
      headingExtra="GA"
      introText="Alpharetta and North Fulton travelers — tech corridor executives, Avalon shoppers heading to Europe, corporate families relocating overseas, and Hartsfield-Jackson (ATL) flyers — have several options for getting a passport fast. Here is how they compare, and why most North Atlanta residents choose a U.S. Department of State registered passport courier for predictable, professional processing without the GA-400 traffic nightmare to downtown Atlanta."
      options={options}
      emergencyDescription="Georgia has only ONE passport agency (Atlanta) serving 11M+ statewide residents — and Alpharetta sits 25 miles north of downtown via GA-400 and I-85, two of the most congested corridors in the Southeast. During rush hour, the 25-mile drive can take 90+ minutes one way. I-85 bridge fires and GA-400 flooding during summer thunderstorms have closed both routes with zero viable alternate paths. Alpharetta's explosive tech corridor growth means thousands of residents with urgent international travel needs are funneling into Atlanta's single agency — which also serves all of Georgia, Alabama's eastern half, and the Carolinas."
      disclaimerText="*Processing speed depends on eligibility and documentation. Alpharetta does not have a regional passport agency — the closest is downtown Atlanta, roughly 25 miles away. Not all applicants qualify for Regional Agency Processing."
    />
  );
}